export const GENERIC_QUERIES = {
  search: 'q',
  page: 'page',
  sort: 'sort',
};

export const PRODUTO_QUERIES = {
  id: 'id',
};

export const COLETA_QUERIES = {
  createdFrom: 'created-from',
  createdBefore: 'created-before',
  codigocliente: 'codigocliente',
};

export const PRESTACAO_QUERIES = {
  createdFrom: 'created-from',
  createdBefore: 'created-before',
  codigocliente: 'codigocliente',
};

export const PESQUISA_CADASTRO_CLIENTE_QUERIES = {
  createdFrom: 'created-from',
  createdBefore: 'created-before',
  codigocliente: 'codigocliente',
};